import * as angular from 'angular';
import { AncillariesUtilsService } from '../../shared/ib-web-ancillaries-utils';

export class AncillariesPriorityTransformer {
    constructor (
        private AncillariesConstants: AncillariesConstant,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CurrencyService: CurrencyService,
        private AncillariesUtilsService: AncillariesUtilsService
    ) {}

    generatePriorityBoardingInfo = (currency: any, slices: any, ancillariesInfo: any, cachedData: any) => {
        const priorityBoarding = {
            currency: ancillariesInfo.currency,
            info: this.generatePriorityOffersInfo(ancillariesInfo.segments, slices, cachedData),
            priceFrom: ancillariesInfo.priceFrom,
            cardPriceFormatted: this.CurrencyService.formatPrice(currency, Math.floor(ancillariesInfo.priceFrom), false, false),
            status: ancillariesInfo.status,
            type: ancillariesInfo.type,
            name: this.AncillariesConstants.PRIORITY_BOARDING.NAME,
            cardCols: this.AncillariesConstants.PRIORITY_BOARDING.CARDCOLS,
            cardType: this.AncillariesConstants.PRIORITY_BOARDING.CARDTYPE,
            cardImg: this.AncillariesConstants.PRIORITY_BOARDING.CARDIMG,
            cardTitle: this.AncillariesConstants.PRIORITY_BOARDING.CARDTITLE,
            cardText: this.AncillariesConstants.PRIORITY_BOARDING.CARDTEXT,
            cardSubtext: this.AncillariesConstants.PRIORITY_BOARDING.CARDSUBTEXT,
            cardSubtextSelect: this.AncillariesConstants.PRIORITY_BOARDING.CARDSUBTEXTSELECT,
            cardButton: this.AncillariesConstants.PRIORITY_BOARDING.CARDBUTTON,
            confirmed: false,
            selectedPriorityBoarding: null,
            modal: this.AncillariesConstants.PRIORITY_BOARDING.MODAL,
            datalayer: this.AncillariesConstants.DATALAYER_INFO.PRIORITY_BOARDING_OPEN
        };
        return priorityBoarding;
    };

    generatePriorityOffersInfo = (segments: any, ancilariesInfoSlices: any, cachedData: any): any => {
        let segmentsInfo, index, i, trip, passenger: any = {};
        const passengersPriority = [], currency: any = this.localStorageService.get('currency'),
            isCheckinFlow = this.AncillariesUtilsService.isCheckinFlow(), bookingInfo = this.localStorageService.get('bookingInfo');

        const getInfoTrip = (isCheckinFlow: any, segmentId: any, segmentsInfo: any): any => {
            let i = 0, isFound = false;
            const info = { departure: null, arrival: null };
            while (i < segmentsInfo.length && !isFound) {
                if (String(segmentsInfo[i].id) === segmentId) {
                    if (isCheckinFlow) {
                        info.arrival = segmentsInfo[i].arrival.airport;
                        info.departure = segmentsInfo[i].departure.airport;
                    } else {
                        info.arrival = segmentsInfo[i].arrival.city;
                        info.departure = segmentsInfo[i].departure.city;
                    }
                    isFound = true;
                }
                i++;
            }
            return info;
        };

        const searchPassenger = (passengersPriority: any, idPassenger: any): any => {
            let i, j, index = -1;
            for (i = 0; i < passengersPriority.length; i++) {
                if (passengersPriority[i].id === idPassenger) {
                    passengersPriority[i].trips.push(trip);
                    index = 0;
                }
            }
            return index;
        };

        const putPassengerType = (isCheckinFlow: any, idPassenger: any, bookingInfo: any): any => {
            let passengerType = '';
            for (let i = 0; i < bookingInfo.passengers.length; i++) {
                if (isCheckinFlow) {
                    if (idPassenger === String(bookingInfo.passengers[i].id)) {
                        passengerType = bookingInfo.passengers[i].type;
                    }
                } else {
                    if (idPassenger === bookingInfo.passengers[i].passengerId) {
                        passengerType = bookingInfo.passengers[i].passengerType;
                    }
                }
            }
            return passengerType;
        };

        const getPriorityInfoPassenger = (id: any): any => {
            const pasInfo: any = {};
            angular.forEach(cachedData.passengers, (pas) => {
                if (pas.passengerId.toString() === id) {
                    pasInfo.name = pas.personalInfo.name;
                    pasInfo.surname = pas.personalInfo.surname;
                    pasInfo.infant = pas.personalInfo.infant;
                }
            });
            return pasInfo;
        };

        const getPriorityInfoCkiPassenger = (id: any): any => {
            const pasInfo: any = {};
            angular.forEach(cachedData.passengers, (pas) => {
                if (pas.id.toString() === id) {
                    pasInfo.name = pas.name;
                    pasInfo.surname = pas.surname;
                    pasInfo.infant = pas.infant;
                }
            });

            return pasInfo;
        };

        const checkPassengersSegments = (segments: any): void => {
            let i = 0, isFound = false, passengerAux = [];
            while (i < segments.length && !isFound) {
                if (segments[i].passengers.length > 0) {
                    passengerAux = {... segments[i].passengers};
                    isFound = true;
                }
                i++;
            }
            for (i = 0; i < passengerAux.length; i++) {
                passengerAux[i].amount = null;
                passengerAux[i].status.code = 'NOT_AVAILABLE';
            }
            for (i = 0; i < segments.length; i++) {
                if (segments[i].passengers.length === 0) {
                    segments[i].passengers = passengerAux;
                }
            }
        };

        const createSlicesSegmentsInfo = (isCheckinFlow: any, segments: any, ancilariesInfoSlices: any, segmentsInfo: any): any => {
            let i, j = 0, isFound;
            const sliceInfo: any = {};

            const getInfoSegment = (isCheckinFlow: any, segmentId: any, segmentsInfo: any): any => {
                let i = 0, isFound = false;
                const info = { departure: null, arrival: null };
                while (i < segmentsInfo.length && !isFound) {
                    if (String(segmentsInfo[i].id) === segmentId) {
                        if (isCheckinFlow) {
                            info.arrival = segmentsInfo[i].arrival.airport;
                            info.departure = segmentsInfo[i].departure.airport;
                        } else {
                            info.arrival = segmentsInfo[i].arrival.city;
                            info.departure = segmentsInfo[i].departure.city;
                        }
                        isFound = true;
                    }
                    i++;
                }
                return info;
            };
            angular.forEach(ancilariesInfoSlices, (slice) => {
                if (slice.segmentIds.length > 1) {
                    isFound = false;
                    j = 0;
                    sliceInfo.departure = getInfoSegment(isCheckinFlow, slice.segmentIds[0], segmentsInfo).departure;
                    sliceInfo.arrival = getInfoSegment(isCheckinFlow, slice.segmentIds[slice.segmentIds.length - 1], segmentsInfo).arrival;
                    for (i = 0; i < slice.segmentIds.length; i++) {
                        while (j < segments.length && !isFound) {
                            if (segments[j].id === slice.segmentIds[i]) {
                                segments[j].withSliceInfo = true;
                                segments[j].sliceInfo = {};
                                segments[j].sliceInfo.departure = sliceInfo.departure;
                                segments[j].sliceInfo.arrival = sliceInfo.arrival;
                                isFound = true;
                            }
                            j++;
                        }
                    }
                } else {
                    j = 0;
                    isFound = false;
                    while (j < segments.length && !isFound) {
                        if (segments[j].id === slice.segmentIds[0]) {
                            segments[j].onlySliceInfo = true;
                            isFound = true;
                        }
                        j++;
                    }
                }
            });
        };
        if (isCheckinFlow) {
            segmentsInfo = this.AncillariesUtilsService.getBookingSegmentInformation();
        } else {
            segmentsInfo = this.AncillariesUtilsService.getMmBbookingSegmentInformation();
        }
        checkPassengersSegments(segments);
        createSlicesSegmentsInfo(isCheckinFlow, segments, ancilariesInfoSlices, segmentsInfo);
        angular.forEach(segments, (segment) => {
            for (i = 0; i < segment.passengers.length; i++) {
                trip = { id: null, amount: segment.passengers[i].amount, tripPrice: this.CurrencyService.formatPrice(currency, segment.passengers[i].amount, true, false), checkedTrip: false };
                if (segment.sliceInfo) {
                    trip.sliceInfo = segment.sliceInfo;
                    trip.withSliceInfo = segment.withSliceInfo;
                } else if (segment.onlySliceInfo) {
                    trip.onlySliceInfo = true;
                } else {
                    trip.withSliceInfo = false;
                }
                trip.id = segment.id;
                trip.status = segment.passengers[i].status.code;
                trip.departure = getInfoTrip(isCheckinFlow, segment.id, segmentsInfo).departure;
                trip.arrival = getInfoTrip(isCheckinFlow, segment.id, segmentsInfo).arrival;
                index = searchPassenger(passengersPriority, segment.passengers[i].id);
                if (index === -1) {
                    passenger = {};
                    passenger = { id: segment.passengers[i].id, trips: [], passengerType: putPassengerType(isCheckinFlow, segment.passengers[i].id, bookingInfo) };
                    passenger.info = this.AncillariesUtilsService.isCheckinFlow() ? getPriorityInfoCkiPassenger(passenger.id) : getPriorityInfoPassenger(passenger.id);
                    passenger.trips.push(trip);
                    passengersPriority.push(passenger);
                }
            }
        });
        return passengersPriority;
    };
}

AncillariesPriorityTransformer.$inject = ['AncillariesConstants', 'localStorageService', 'CurrencyService', 'AncillariesUtilsService'];
try {
    const mod = angular.module('ib-web-ancillaries-module');
    mod.service('AncillariesPriorityTransformer', AncillariesPriorityTransformer);
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-module', []);
    mod.service('AncillariesPriorityTransformer', AncillariesPriorityTransformer);
}
